import * as yup from 'yup';

const PatientFormSchema = yup.object({
    patient_first_name: yup.string().required("Patient First Name is Required"),
    patient_middle_name: yup.string().optional(),
    patient_last_name: yup.string().required("Patient Last Name is Required"),
    dob: yup.string().required("Date of Birth is Required"),
    sex: yup.string().required("Gender is Required"),
    ethnicity: yup.string().required("Ethnicity is Required"),
    marital_status: yup.string().required("Marital Status is Required"),
    education_level: yup.string().optional(),
    occupation: yup.string().optional(),
    country_of_origin: yup.string().required("Country of Origin is Required"),
    client_is_handicapped: yup.string().optional(),
    disability: yup.string().optional(),
    permanent_residential_address: yup.string().required("Permanent Residential Address is Required"),
    inkhundla: yup.string().required("Inkhundla is Required"),
    chiefdom: yup.string().required("Chiefdom is Required"),
    current_residential_address: yup.string().required("Current Residential Address is Required"),
    postal_address: yup.string().optional(),
    primary_cellphone: yup.string().required("Primary Cellphone is Required").max(8, "The primary cellphone number must have 8 digits").min(8, "The primary cellphone number must have 8 digits"),
    secondary_cellphone: yup.string().max(8, "The secondary cellphone number must have 8 digits").min(8, "The secondary cellphone number must have 8 digits").nullable(true).transform((value) => (value === "" ? null : value)),
    land_phone: yup.string().max(8, "Landline phone number must have 8 digits").min(8, "Landline phone number must have 8 digits").nullable(true).transform((value) => (value === "" ? null : value)),
    patient_email_id: yup.string().nullable().optional(),
    national_id: yup.string().required("National ID is Required").max(13, "National ID must be 13 digits").min(13, "National ID must be 13"),
    patient_region: yup.string().required("Patient Region is Required"),
    CMIS_id: yup.string().optional(),
    patient_code: yup.string().required("Patient Code is Required"),
    nurse_id: yup.number().integer().required("Nurse ID must be an integer"),
    nurse_name: yup.string().required("Nurse Name is Required"),
    question1: yup.string().optional(),
    question2: yup.string().optional(),
    question3: yup.string().optional(),
    year: yup.number().integer().required("Year must be an integer"),
  });

export default PatientFormSchema;